export default {"src":"/_next/static/media/icon-revenge-porn.5d0b6714.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};